export class TrackingData {
    cc: string
    locale: string
    xClient: string
    tcli: string
    ch: string
    fl: string
    context: string
    pageview_id: string
    userid: string
    company_id: string
  }